"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactLoaderSpinner = _interopRequireDefault(require("react-loader-spinner"));
var _styled = require("../../base/styled");
var _arrowDown = _interopRequireDefault(require("../../../assets/svg/arrow-down.svg"));
var _newArrow = _interopRequireDefault(require("../../../assets/svg/new-arrow.svg"));
var _styled2 = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var CustomDropdown = function CustomDropdown(_ref) {
  var onChange = _ref.onChange,
    options = _ref.options,
    isLoading = _ref.isLoading,
    value = _ref.value,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    noRemove = _ref.noRemove,
    styles = _ref.styles,
    newArrow = _ref.newArrow;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    menuOpen = _useState2[0],
    setMenuOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    withoutValue = _useState4[0],
    setWithoutValue = _useState4[1];
  var containerRef = (0, _react.useRef)(null);
  var selectedId = value ? value.id : withoutValue === null || withoutValue === void 0 ? void 0 : withoutValue.id;
  var getName = function getName() {
    var _options$find;
    return ((_options$find = options.find(function (option) {
      return option.id === selectedId;
    })) === null || _options$find === void 0 ? void 0 : _options$find.name) || placeholder;
  };
  var getOptions = function getOptions() {
    return options.filter(function (option) {
      return option.id !== selectedId;
    });
  };
  var handleChange = function handleChange(selectedOption) {
    setMenuOpen(false);
    onChange(selectedOption);
    setWithoutValue(selectedOption);
  };
  var handleClickOutside = function handleClickOutside(event) {
    if (!containerRef || !containerRef.current.contains(event.target)) {
      setMenuOpen(false);
    }
  };
  var handleRemove = function handleRemove(e) {
    e.preventDefault();
    e.stopPropagation();
    setMenuOpen(false);
    onChange(null);
    setWithoutValue(null);
  };
  (0, _react.useEffect)(function () {
    document.addEventListener('click', handleClickOutside, true);
    return function () {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_styled2.Container, {
    $bsStyle: styles.container,
    ref: containerRef
  }, /*#__PURE__*/_react.default.createElement(_styled2.Button, {
    $bsStyle: styles.button,
    onClick: function onClick() {
      return setMenuOpen(!menuOpen);
    },
    disabled: disabled
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_styled.Row, {
    center: true
  }, /*#__PURE__*/_react.default.createElement(_reactLoaderSpinner.default, {
    type: "TailSpin",
    color: "white",
    height: 24,
    width: 24
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styled.Row, {
    center: true,
    $bsStyle: {
      marginLeft: disabled ? 'initial' : '40px'
    }
  }, getName()), !noRemove && selectedId && !disabled && /*#__PURE__*/_react.default.createElement(_styled2.RemoveButton, {
    onClick: handleRemove
  }), !disabled && /*#__PURE__*/_react.default.createElement(_styled2.Indicator, {
    $bsStyle: styles.indicator
  }, /*#__PURE__*/_react.default.createElement(_styled2.ArrowDown, {
    menuOpen: menuOpen,
    src: newArrow ? _newArrow.default : _arrowDown.default
  })))), /*#__PURE__*/_react.default.createElement(_styled2.MenuList, {
    $bsStyle: styles.menu,
    id: "menu",
    menuOpen: menuOpen
  }, /*#__PURE__*/_react.default.createElement(_styled2.Options, {
    $bsStyle: styles.options,
    visibility: menuOpen
  }, getOptions().map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_styled2.Option, {
      $bsStyle: styles.option,
      key: option.id,
      onClick: function onClick() {
        return handleChange(option);
      }
    }, option.name);
  }))));
};
CustomDropdown.propTypes = {
  placeholder: _propTypes.default.string,
  isLoading: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  noRemove: _propTypes.default.bool,
  newArrow: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  styles: _propTypes.default.shape({
    container: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.string]),
    button: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.string]),
    menu: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.string]),
    options: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.string]),
    option: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.string]),
    indicator: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.string])
  }),
  value: _propTypes.default.shape({
    id: _propTypes.default.number,
    value: _propTypes.default.string
  }),
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    value: _propTypes.default.string
  }))
};
CustomDropdown.defaultProps = {
  placeholder: 'Select',
  noRemove: false,
  onChange: function onChange() {
    return {};
  },
  styles: {
    container: null,
    button: null,
    menu: null,
    options: null,
    option: null,
    indicator: null
  },
  options: [],
  isLoading: false,
  value: null,
  disabled: false,
  newArrow: false
};
var _default = CustomDropdown;
exports.default = _default;